/* eslint-env browser */

(function (window, document) {
    'use strict';

    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion || !('IntersectionObserver' in window)) {
        return;
    }

    var selector = [
        '.home-template .hub-section-heading',
        '.home-template .hub-card:not(.hub-card--hero)',
        '.home-template .hub-category-card',
        '.home-template .hub-topics',
        '.home-template .hub-latest-feed .post-card',
        '.tag-template .tag-hub-header',
        '.tag-template .tag-hub-grid .hub-card'
    ].join(',');
    var revealSequence = 0;

    var observer = new window.IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
                return;
            }

            var element = entry.target;
            element.classList.remove('is-reveal-pending');
            element.classList.add('is-revealed');
            observer.unobserve(element);

            window.setTimeout(function () {
                element.classList.add('is-reveal-complete');
                element.style.removeProperty('--reveal-delay');
            }, 850);
        });
    }, {
        rootMargin: '0px 0px -12% 0px',
        threshold: 0.12
    });

    function prepare(element) {
        if (element.getAttribute('data-reveal-bound')) {
            return;
        }

        element.setAttribute('data-reveal-bound', 'true');
        element.classList.add('reveal-item');

        var bounds = element.getBoundingClientRect();
        if (bounds.top < window.innerHeight * 0.68 && bounds.bottom > 0) {
            element.classList.add('is-revealed', 'is-reveal-complete');
            return;
        }

        element.style.setProperty('--reveal-delay', ((revealSequence % 3) * 80) + 'ms');
        revealSequence += 1;
        element.classList.add('is-reveal-pending');
        observer.observe(element);
    }

    function scan(root) {
        if (root.matches && root.matches(selector)) {
            prepare(root);
        }

        if (!root.querySelectorAll) {
            return;
        }

        var elements = root.querySelectorAll(selector);
        for (var index = 0; index < elements.length; index += 1) {
            prepare(elements[index]);
        }
    }

    scan(document);

    if ('MutationObserver' in window) {
        var mutationRoot = document.querySelector('.site-content');
        var mutationObserver = new window.MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                for (var index = 0; index < mutation.addedNodes.length; index += 1) {
                    scan(mutation.addedNodes[index]);
                }
            });
        });

        if (mutationRoot) {
            mutationObserver.observe(mutationRoot, {
                childList: true,
                subtree: true
            });
        }
    }
})(window, document);
